class FacetsSort extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', this.onRadioChange.bind(this));
    });
  }

  onRadioChange(event) {
    if (this.details) this.details.removeAttribute('open');

    this.querySelectorAll('.facets-sort__option').forEach((label) => {
      label.classList.toggle('facets-sort__option--selected', label.querySelector('input') === event.target);
    });

    if (!this.closest('facet-filters-form')) {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', event.target.value);
      FacetFiltersForm.renderPage(params.toString());
    }
  }
}

customElements.define('facets-sort', FacetsSort);
